import {
  CHECKOUT_SUBMIT,
  CHECKOUT_SUBMIT_ERROR,
  CHECKOUT_SET_CUSTOMER_INFO,
  CHECKOUT_SET_CAMPAIGN_CODE,
  CHECKOUT_SET_DELIVERY,
  CHECKOUT_SET_PAYMENT,
  CHECKOUT_SET_ORDER_NOTE,
  CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  CHECKOUT_SAVE_CART_ON_PURCHASE,
  CHECKOUT_SET_PRIVATE_CUSTOMER,
  CHECKOUT_SET_PAYMENT_WIDGET,
  CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  CHECKOUT_SET_SIGN_UP,
  CHECKOUT_SET_COUNTRY,
  CHECKOUT_SET_SELECTED_CERTIFICATE,
  CHECKOUT_SET_DELIVERYCONTACTPERSON,
  CHECKOUT_SET_SELECTED_DELIVERYCONTACTPERSONPHONE,
  CHECKOUT_SET_ORDERMARKING,
  CHECKOUT_SET_GENERALMARKING,
  CHECKOUT_SET_SELECTED_SALESREP,
  CHECKOUT_SET_DOOPTIMIZATION,
  CHECKOUT_SET_IS_VALID_FORM,
  SAVECART_MODAL_UPDATE,
  CHECKOUT_SET_CHOICE_DELIVERY,
  CHECKOUT_SET_CHOICE_DELIVERY_DATE,
  CHECKOUT_SET_ORDER_HISTORY,
  UPDATE_ORDER_HISTORY_LOADING,
  CHECKOUT_SET_ORGANIZATION_USER,
  UPDATE_ORGANIZATION_USER
} from "../Actions/Checkout.action";
import { error as errorReducer } from "./Error.reducer";
const defaultState = {
  payload: {
    alternativeAddress: {},
    customerDetails: {},
    selectedCompanyAddressId: null,
    selectedDeliveryMethod: {},
    selectedPaymentMethod: {},
    selectedCountry: "",
    discountCode: "",
    orderNote:"",
    paymentWidget: null,
    isBusinessCustomer: false,
    signUp: false,
    acceptTermsOfCondition: false,
    saveCartOnPurchase: false,
    authenticated: false,
    deliveryMethods: [],
    paymentMethods: [],
    companyAddresses: [],
    responseUrl: "",
    cancelUrl: "",
    redirectUrl: "",
    selectedCertificateId: "",
    deliveryContactPersonName: "",
    deliveryContactPersonPhoneNumber: "",
    orderMarking: "",
    generalNote: "",
    selectedSalesRepId: "0",
    doOptimization: false,
    selectedTempAddress: {},
    saveCartTitle: "",
    isValidForm: false,
    isOrderHistoryLoading: false,
    orderHistory: [],
    organizationUsers: [],
    selectedOrganizationUser:""
  },
  errors: {},
  result: {},
  isSubmitting: false,
};

export const checkout = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHECKOUT_SUBMIT_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case CHECKOUT_SUBMIT:
      return {
        ...state,
        ...payload,
      };
    case CHECKOUT_SET_CUSTOMER_INFO:
      return {
        ...state,
        payload: {
          ...state.payload,
          [payload.key]: {
            ...state.payload[payload.key],
            ...payload.data,
          },
        },
      };
    case CHECKOUT_SET_DELIVERY:
    case CHECKOUT_SET_PAYMENT:
    case CHECKOUT_SET_ORDER_NOTE:
    case CHECKOUT_SET_PAYMENT_WIDGET:
    case CHECKOUT_SET_PRIVATE_CUSTOMER:
    case CHECKOUT_SET_SIGN_UP:
    case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
    case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
    case CHECKOUT_SAVE_CART_ON_PURCHASE:
    case CHECKOUT_SET_CAMPAIGN_CODE:
    case CHECKOUT_SET_SELECTED_CERTIFICATE:
    case CHECKOUT_SET_SELECTED_SALESREP:
    case CHECKOUT_SET_DELIVERYCONTACTPERSON:
    case CHECKOUT_SET_SELECTED_DELIVERYCONTACTPERSONPHONE:
    case CHECKOUT_SET_GENERALMARKING:
    case CHECKOUT_SET_ORDERMARKING:
    case CHECKOUT_SET_DOOPTIMIZATION:
    case SAVECART_MODAL_UPDATE:
    case CHECKOUT_SET_COUNTRY:
    case CHECKOUT_SET_IS_VALID_FORM:
    case CHECKOUT_SET_CHOICE_DELIVERY:
    case CHECKOUT_SET_CHOICE_DELIVERY_DATE:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
        },
      };
    case CHECKOUT_SET_ORDER_HISTORY:
      return {
        ...state,
        payload: {
          ...state.payload,
          orderHistory: payload,
          isOrderHistoryLoading: true,
        },
      };
    case UPDATE_ORDER_HISTORY_LOADING:
      return {
        ...state,
        payload: {
          ...state.payload,
          isOrderHistoryLoading: payload,
        },
      };
    case CHECKOUT_SET_ORGANIZATION_USER:
      return {
        ...state,
        payload: {
          ...state.payload,
          organizationUsers: payload,
        },
      };
      case UPDATE_ORGANIZATION_USER:
        return {
          ...state,
          payload: {
            ...state.payload,
            selectedOrganizationUser: payload,
          },
        };
    default:
      return state;
  }
};
